import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { DISCOUNT_TYPES } from "@utils/Constants";

const FormConfig = {
    submit: {
        label: "Aceptar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "discountType",
                        "label": "Tipo Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "options": DISCOUNT_TYPES
                    },
                ],
            ]
        }
    ],
};


export default FormConfig;